const throttle =  (callback, wait, context = this) => {
    let timeout = null
    let callbackArgs = null

    const later = () => {
        callback.apply(context, callbackArgs)
        timeout = null
    }

    return function() {
        if (!timeout) {
            callbackArgs = arguments
            timeout = setTimeout(later, wait)
        }
    }
}

const debounce = (fn, time) => {
    let timeout;

    return function() {
        const functionCall = () => fn.apply(this, arguments);

        clearTimeout(timeout);
        timeout = setTimeout(functionCall, time);
    }
}

const inputsToObjectValues = ($inputs) => {
    const values = {}
    $inputs.forEach($input => {
        const name = $input.getAttribute("name")
        const value = $input.value
        if ( $input.getAttribute("type") === "checkbox" ) {
            if ( $input.checked ) {
                values[name] = 1
            } else {
                values[name] = 0
            }
        } else {
            values[name] = value
        }
    })
    return values
}

const triggerDownload = filePath =>{
    const a = document.createElement('A')
    a.href = filePath
    a.download = filePath.substr(filePath.lastIndexOf('/') + 1)
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
}

const isString = e => typeof e === 'string' || e instanceof String

const diffInMinutes = (dt2, dt1) => {
    let diff = (dt2 - dt1) / 1000
    diff /= 60
    return Math.abs(Math.round(diff))
}

const shuffleArray = arr => arr
    .map(a => [Math.random(), a])
    .sort((a, b) => a[0] - b[0])
    .map(a => a[1])


export  {
    inputsToObjectValues,
    isString,
    diffInMinutes,
    throttle,
    debounce,
    triggerDownload,
    shuffleArray
}
